exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-llantas-js": () => import("./../../../src/pages/llantas.js" /* webpackChunkName: "component---src-pages-llantas-js" */),
  "component---src-pages-rines-js": () => import("./../../../src/pages/rines.js" /* webpackChunkName: "component---src-pages-rines-js" */)
}

